import { render, staticRenderFns } from "./company.vue?vue&type=template&id=3178a779&scoped=true&"
import script from "./company.vue?vue&type=script&lang=ts&"
export * from "./company.vue?vue&type=script&lang=ts&"
import style0 from "./company.vue?vue&type=style&index=0&id=3178a779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178a779",
  null
  
)

export default component.exports